(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.theme.currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* sticky header shadow */
  var hdr = $('#hdr');
  if (hdr) window.addEventListener('scroll', function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); }, { passive: true });

  /* mobile nav */
  var nav = $('#nav'), scrim = $('.scrim');
  function navToggle(open) { if (!nav) return; nav.classList.toggle('is-open', open); scrim.classList.toggle('is-on', open); document.body.style.overflow = open ? 'hidden' : ''; }
  $$('[data-nav-open]').forEach(function (b) { b.addEventListener('click', function () { navToggle(true); }); });
  $$('[data-nav-close]').forEach(function (b) { b.addEventListener('click', function () { navToggle(false); }); });

  /* cart count */
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }

  /* wishlist (stored in this browser) */
  var WK = 'her_wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return []; } }
  function wlSave(a) { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} }
  function wlPaint() {
    var a = wl();
    $$('[data-wish]').forEach(function (b) { b.classList.toggle('is-on', a.indexOf(b.getAttribute('data-wish')) > -1); });
    $$('[data-wish-count]').forEach(function (el) { el.textContent = a.length; el.hidden = !a.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), a = wl(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); toast('Removed from wishlist'); } else { a.push(h); toast('Saved to wishlist'); }
    wlSave(a); wlPaint();
    if ($('[data-wishlist-grid]')) renderWishlist();
  });
  function renderWishlist() {
    var grid = $('[data-wishlist-grid]'), empty = $('[data-wishlist-empty]'), a = wl();
    empty.hidden = a.length > 0; grid.innerHTML = '';
    a.forEach(function (h) {
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var off = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        var src = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var img = src ? '<img src="' + src + '" alt="" loading="lazy">' : '';
        var d = document.createElement('article'); d.className = 'card';
        d.innerHTML = '<div class="card__media"><a href="' + p.url + '">' + img + '</a><button class="wish is-on" type="button" data-wish="' + h + '" aria-label="Remove from wishlist"><svg class="ic" viewBox="0 0 24 24"><path d="M12 20s-7-4.4-9-9a5 5 0 0 1 9-3 5 5 0 0 1 9 3c-2 4.6-9 9-9 9z"/></svg></button></div><div class="card__body"><p class="card__brand">' + (p.vendor || '') + '</p><h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3><p class="price"><strong>' + money(p.price) + '</strong>' + off + '</p></div>';
        grid.appendChild(d);
      }).catch(function () {});
    });
  }
  wlPaint();
  if ($('[data-wishlist-grid]')) renderWishlist();

  /* carousels */
  $$('[data-scroll]').forEach(function (b) {
    b.addEventListener('click', function () {
      var rail = b.closest('section').querySelector('[data-rail]');
      rail.scrollBy({ left: rail.clientWidth * 0.9 * Number(b.getAttribute('data-scroll')), behavior: 'smooth' });
    });
  });

  /* hero slider */
  $$('[data-hero]').forEach(function (h) {
    var track = $('.hero__track', h), dots = $$('.hero__dots button', h), n = dots.length, i = 0, timer;
    if (n < 2) return;
    function go(k) { i = (k + n) % n; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    track.addEventListener('scroll', function () {
      var k = Math.round(track.scrollLeft / track.clientWidth); i = k;
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    dots[0].classList.add('is-on');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var start = function () { timer = setInterval(function () { go(i + 1); }, 5500); };
      h.addEventListener('mouseenter', function () { clearInterval(timer); });
      h.addEventListener('mouseleave', start); start();
    }
  });

  /* countdown */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown').replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    function pad(x) { return String(x).padStart(2, '0'); }
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
      $('[data-h]', el).textContent = pad(Math.floor(s % 86400 / 3600));
      $('[data-m]', el).textContent = pad(Math.floor(s % 3600 / 60));
      $('[data-s]', el).textContent = pad(s % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* predictive search */
  var si = $('[data-suggest]'), box = $('[data-suggest-box]'), st;
  if (si && box) {
    si.addEventListener('input', function () {
      clearTimeout(st); var q = si.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      st = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); }).then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { box.hidden = true; return; }
            box.innerHTML = items.map(function (p) {
              var im = p.image ? '<img src="' + p.image + '" alt="">' : '';
              return '<a href="' + p.url + '">' + im + '<span>' + p.title + '<small>' + (p.vendor || '') + '</small></span></a>';
            }).join('');
            box.hidden = false;
          }).catch(function () { box.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.search')) box.hidden = true; });
  }

  /* collection filters */
  var fp = $('#filters-panel');
  $$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', function () { fp.classList.add('is-open'); }); });
  $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { fp.classList.remove('is-open'); }); });
  var ff = $('#filters');
  if (ff) ff.addEventListener('change', function (e) {
    if (e.target.hasAttribute('data-autosubmit') && window.matchMedia('(min-width: 900px)').matches) ff.submit();
  });
  if (ff) ff.addEventListener('submit', function () { $$('input[type=number]', ff).forEach(function (i) { if (!i.value) i.disabled = true; }); });
  if (ff) $$('[data-filters-close]', ff).forEach(function (b) { if (b.classList.contains('btn')) b.addEventListener('click', function () { ff.submit(); }); });

  /* quantity steppers + cart qty */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    var input = b.parentNode.querySelector('input'), min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(b.getAttribute('data-q')));
    if (input.hasAttribute('data-autosubmit-qty')) input.form.submit();
  });
  $$('[data-autosubmit-qty]').forEach(function (i) { i.addEventListener('change', function () { i.form.submit(); }); });

  /* product page */
  $$('[data-product]').forEach(function (root) {
    var form = $('#product-form', root);
    var variants = JSON.parse($('[data-variants]', form).textContent);
    var main = $('#main-img', root), zoom = $('[data-zoom]', root);

    $$('.thumb', root).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.thumb', root).forEach(function (x) { x.classList.remove('is-on'); }); t.classList.add('is-on');
        if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-large'); }
      });
    });
    if (zoom && window.matchMedia('(hover: hover)').matches) {
      zoom.addEventListener('mouseenter', function () { zoom.classList.add('is-zoom'); });
      zoom.addEventListener('mouseleave', function () { zoom.classList.remove('is-zoom'); });
      zoom.addEventListener('mousemove', function (e) {
        var r = zoom.getBoundingClientRect();
        zoom.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        zoom.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    }

    function selected() { return $$('[data-opt]', form).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; }); }
    function onVariant() {
      var sel = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); })[0];
      var add = $('[data-add]', form), buy = $('[data-buy]', form), price = $('[data-price]', root);
      if (!v) { add.disabled = buy.disabled = true; add.textContent = 'Unavailable'; return; }
      $('[data-variant-id]', form).value = v.id;
      add.disabled = buy.disabled = !v.available;
      add.textContent = v.available ? 'Add to bag' : 'Sold out';
      var html = '<strong>' + money(v.price) + '</strong>';
      if (v.compare_at_price > v.price) html += '<s>' + money(v.compare_at_price) + '</s><span class="off">' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off</span>';
      price.innerHTML = html;
      if (v.featured_image && main) { main.removeAttribute('srcset'); main.src = v.featured_image.src; }
      history.replaceState(null, '', root.getAttribute('data-product-url') + '?variant=' + v.id);
    }
    $$('[data-opt] input', form).forEach(function (i) { i.addEventListener('change', onVariant); });

    form.addEventListener('submit', function (e) {
      var s = e.submitter; if (s && s.name === 'checkout') return;
      e.preventDefault();
      var btn = $('[data-add]', form); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Could not add to bag'); return d; }); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (c) { setCartCount(c.item_count); toast('Added to bag'); })
        .catch(function (err) { toast(err.message); })
        .then(function () { btn.disabled = false; });
    });
  });

  /* recommendations */
  $$('[data-recs]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html'), n = $('[data-recs]', doc);
      if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; wlPaint(); }
    }).catch(function () {});
  });
})();
